//formate un nombre 12345.2 sous la forme 1 2345,2
export function format(num) {
    const n = String(num),
          p = n.indexOf('.')
    return n.replace(
        /\d(?=(?:\d{3})+(?:\.|$))/g,
        (m, i) => p < 0 || i < p ? `${m} ` : m
    ).replace('.', ',')
}